import { MetricField, MetricUnit } from '@/__generated__/graphql';
import { type I18n } from '@lingui/core';
import { getUnitsPerMetric } from '@/utils/getUnitsPerMetric';

export const CENTIMETER_FIELDS: MetricField[] = [
  MetricField.Level,
  MetricField.LevelRaw,
  MetricField.OriginalDistance,
  MetricField.Position,
  MetricField.GateSensorDistance,
  MetricField.SnowLevel,
  MetricField.SnowLevelNonCalibrated,
  MetricField.SnowWaterEquivalent,
  MetricField.SnowWaterEquivalentNonCalibrated,
];

export const CUBIC_METER_FIELDS: MetricField[] = [
  MetricField.AccumulatedVolume,
  MetricField.VolumeDay,
  MetricField.VolumeHour,
  MetricField.VolumeMonth,
];

export const getDefaultUnit = (field: MetricField, i18n: I18n): MetricUnit | null => {
  if (CENTIMETER_FIELDS.includes(field)) return MetricUnit.Centimeter;
  if (CUBIC_METER_FIELDS.includes(field)) return MetricUnit.CubicMeter;
  return getUnitsPerMetric(field, i18n).at(0)?.enumValue ?? null;
};

/** Converts a MetricUnit enum value to its string representation (e.g. "l/s"). */
export const getUnitValue = (field: MetricField, unit: MetricUnit | undefined, i18n: I18n): string => {
  const units = getUnitsPerMetric(field, i18n);
  if (unit) {
    return units.find((u) => u.enumValue === unit)?.value ?? units.at(0)?.value ?? '';
  }
  return units.at(0)?.value ?? '';
};
